import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Prompt, Redirect } from "react-router";
import AddPageComponent from "../editor/AddPageComponent";
import {
  Badge,
  Button,
  Drawer,
  Dropdown,
  Empty,
  Icon,
  Menu,
  Modal,
  Popconfirm,
  Tooltip,
} from "antd";
import "./Editor.css";
import { getCurrentWebsiteSubdomain } from "../../helpers/getCurrentWebsiteSubdomain";
import { getCurrentWebsitePageUrl } from "../../helpers/getCurrentWebsitePageUrl";
import PageComponent from "../../pageComponents/PageComponent";
import SpinnerBox from "./SpinnerBox";
import { api, apiUrlBase } from "../../data/urls";
import axios from "axios";
import returnAuthHeaderForAJAX from "../../helpers/auth/returnAuthHeaderForAJAX";
import { openNotification } from "../../helpers/openNotification";
import {
  PATH_HISTORY_LS_KEY,
  notificationDuration,
} from "../../data/constants";
import { getCurrentWebsite } from "../../helpers/getCurrentWebsite";
import generateContentDataObject from "../../helpers/editor/generateContentDataObject";
import { checkIfPageHasComponents } from "../../helpers/editor/checkIfPageHasComponents";
import { checkIfComponentHasDarkBg } from "../../helpers/editor/checkIfComponentHasDarkBg";
import fireAnalyticsEvent from "../../helpers/editor/fireAnalyticsEvent";
import { getErrorKey } from "../../helpers/editor/getErrorKey";
import { getErrorValue } from "../../helpers/editor/getErrorValue";
import { applyCustomColorsClassnames } from "../../helpers/editor/applyCustomColorsClassnames";
import CustomColorsStyles from "../editor/CustomColorsStyles";
import CustomFontsStyles from "../editor/CustomFontsStyles";
// import useMousetrap from "react-hook-mousetrap";
import { handleBadWebsiteError } from "../../helpers/handleBadWebsiteError";
import PopupComponents from "../editor/popups/PopupComponents";
import PopupMask from "../editor/popups/PopupMask";
import _ from "lodash";
import {
  ChangeWebsitesStateGlobalData,
  EditFillTemplateData,
  GetCurrentStoreData,
  SaveWebsiteBackup,
  ToggleLoadedWebsitesData,
} from "../../store/websites/types";
import {
  ChangeComponentGlobalData,
  ChangePageItemGlobalData,
  ChangeWebsitePagesStateGlobalData,
  SavePageComponentsInState,
  ToggleIsPageEmpty,
} from "../../store/websitePages/types";
import { CrispEvents, PosthogEvents } from "../../enums/AnalyticsEventsEnums";
import { setUserEventsAsync } from "../../helpers/user/setUserEventsAsync";
import { UserEvents } from "../../enums/UserEvents";
import { SaveUserEventsInStore } from "../../store/user/types";
import WebsiteNav from "../../pageComponents/component_molecules/WebsiteNav";
import WebsiteFooter from "../../pageComponents/component_molecules/WebsiteFooter";
import {
  AbortControllersRef,
  GptInputObject,
  GptPopoverObject,
  OnGptClick,
  QueueItem,
  SetValueAndResizeTextArea,
} from "../editor/ai2/types";
import {
  GetCurrentChatData,
  GptState,
  HandleOnUnmount,
  SetMode,
} from "../../store/gpt/types";
import FillTemplateModalContent from "./fill_template_modal_content/FillTemplateModalContent";
import FillTemplateProgressIndicator from "./fill_template_modal_content/FillTemplateProgressIndicator";
import GenerateButton from "./fill_template_modal_content/GenerateButton";
import { getMetaDataFromComponentsArray } from "../../helpers/getMetaDataFromComponentsArray";
import CustomStyles from "../CustomStyles";
import { getCustomStyleClassNames } from "../../helpers/editor/getCustomStyleClassNames";
import { LoadStatus } from "../../enums/enums";
import { getCurrentPageId } from "../../helpers/getCurrentPageId";
import { getCurrentSubdomain } from "../../helpers/getCurrentSubdomain";
import { MetaState } from "../../store/meta/types";
import { checkIfObjectEmpty } from "../../helpers/checkIfObjectEmpty";
import VersionMismatchModal from "./VersionMismatchModal";
import { replaceDynamicVariables } from "../../helpers/editor/replaceDynamicVariables";
import getUrlParameter from "../../helpers/getUrlParameter";
import classNames from "classnames";
import { addPreviewFlag } from "../../helpers/addPreviewFlag";
import {
  ExternalLink,
  Save,
  Clipboard as ClipboardIcon,
  MoveUpRight,
  ArrowUpRight,
  Settings,
  Copy,
  CornerUpRight,
  Trash2,
  Ellipsis,
} from "lucide-react";
import LoaderAnimated from "./LoaderAnimated";
import { getFullPageUrl } from "../../helpers/editor/getFullPageUrl";
import addNoCacheParamToURL from "../../helpers/editor/addNoCacheParamToURL";
import { formatToURLPath } from "../../helpers/strings/formatToURLPath";
import { checkIfPageIsDynamic } from "../../helpers/checkIfPageIsDynamic";
import { getPathArray } from "../../helpers/getPathArray";
import PageBottomBar from "./PageBottomBar";
import MovePagePopover from "../layout/MovePagePopover";
import DeleteButtons from "./DeleteButtons";
import EditItemDataIframe from "./EditItemDataIframe";
import "./EditItemData.scss";

interface State {
  addPageComponentWindowVisible: boolean;
  newComponentPosition: number;
  showSaveButtonSuccess: boolean;
  doesComponentClipboardHaveItem: boolean;
  firstComponentWasEdited: boolean;
  gptInputValue: string;
  gptIsPopoverVisible: boolean;
}
interface Props {
  pageComponents: any;
  pageComponentCategories: any;
  user: any;
  auth: any;
  websitesPages: any;
  websites: any;
  formIntegrations: any;
  history: any;
  gpt: GptState;
  meta: MetaState;

  editWebsitePageSchemeToggleWaitingForServer: any;
  toggleNewWebsitePageEditionsDetected: any;
  moveWebsitePageComponent: any;
  deleteWebsitePageComponent: any;
  changeWebsitePageComponentContent: any;
  addWebsitePageComponent: any;
  pasteCopiedWebsitePageComponent: any;

  saveWebsiteNavInState: any;
  saveWebsiteFooterInState: any;

  toggleWebsiteNavEditionsDetected: any;
  toggleWebsiteFooterEditionsDetected: any;

  toggleWaitingForResponseOnWebsiteFooterEditions: any;
  toggleWaitingForResponseOnWebsiteNavEditions: any;

  saveWebsiteNewFormIntegrationInState: any;
  toggleWaitingForResponseOnWebsiteFormIntegrationAdd: any;
  changeWebsitePageComponentBackgroundColor: any;
  changeWebsitePageComponentBackgroundImage: any;
  changeWebsitePageComponentBackgroundImageOverlayOpacity: any;
  changeWebsitePageComponentPaddingTop: any;
  changeWebsitePageComponentPaddingBottom: any;
  removeWebsiteFormIntegration: any;

  toggleWaitingForConnectPaymentIntegration: any;
  toggleWaitingForChangePaymentIntegrationProductsArray: any;
  toggleWaitingForEditPaymentIntegrationProductDetails: any;
  toggleWaitingForConfigurePaymentIntegration: any;

  toggleWaitingForCommonWebsiteUpdate: any;

  changeWebsiteNavColor: any;

  saveImageInfoInDB: any;
  removeImageFromDB: any;

  changeStripeSecretKey: any;
  changeStripePublicKey: any;
  changeStripeCheckoutProductsArray: any;

  saveWebsiteDataInStore: any;

  changeWebsitePageComponentVisibility: any;

  toggleIsPageNavHidden: any;
  toggleIsPageFooterHidden: any;
  toggleNewWebsitePageNavEditionsDetected: any;

  toggleWebsiteCaptchaEditionsDetected: any;
  toggleWaitingForResponseOnWebsiteCaptchaEditions: any;

  toggleWebsitePopupEditionsDetected: any;
  toggleWaitingForResponseOnWebsitePopupEditions: any;

  toggleLoadedWebsitesData: ToggleLoadedWebsitesData;
  savePageComponentsInState: SavePageComponentsInState;
  toggleIsPageEmpty: ToggleIsPageEmpty;
  saveUserEventsInStore: SaveUserEventsInStore;

  navEditionFieldsVisible: boolean;
  showNavEditionFieldsDrawer: () => void;
  hideNavEditionFieldsDrawer: () => void;
  displayNavOrFooterEditionBox: any;
  blogs: any;
  saveBlogNavInState: any;
  toggleBlogNavEditionsDetected: any;

  footerEditionFieldsVisible: boolean;
  saveBlogFooterInState: any;
  showFooterEditionFieldsDrawer: any;
  hideFooterEditionFieldsDrawer: any;
  toggleBlogFooterEditionsDetected: any;
  setMode: SetMode;
  getCurrentChatData: GetCurrentChatData;
  editFillTemplateData: EditFillTemplateData;

  currentWebsite: any;
  currentWebsitePageUrl: any;
  currentWebsitePage: any;
  handleOnUnmount: HandleOnUnmount;
  changeComponentGlobalData: ChangeComponentGlobalData;
  changeWebsitePagesStateGlobalData: ChangeWebsitePagesStateGlobalData;
  changePageItemGlobalData: ChangePageItemGlobalData;
  changeWebsitesStateGlobalData: ChangeWebsitesStateGlobalData;
  getCurrentStoreData: GetCurrentStoreData;
  saveWebsiteBackup: SaveWebsiteBackup;
  getPageLoadStatus: any;
  setPageLoadStatus: any;
  saveSinglePageInStore: any;
  getSingleWebsiteLoadStatus: any;

  saveToLocalBackup: any;
  changeWebsiteItemGlobalData: any;

  pasteCopiedComponent: any;
  getPageDynamicData: any;
  publishPage: any;
  isUserFreeNew: any;
  previewPage: any;

  setSettingsModalType: any;
  setIsSettingsModalVisible: any;

  duplicatePage: any;
  deletePage: any;
  saveWebsiteNavInServer: any;
  saveBlogNavInServer: any;
  saveWebsiteFooterInServer: any;
}
class Editor extends Component<Props> {
  gptTextAreaRef: React.RefObject<HTMLTextAreaElement>;
  isForceDontOpenPresetsRef: React.MutableRefObject<boolean>;
  gptAssistantComponentRef: React.MutableRefObject<any>;
  queueDataRef: React.MutableRefObject<QueueItem[]>;
  intervalRef: React.MutableRefObject<NodeJS.Timeout>;
  forceStopAllFlagRef: React.MutableRefObject<boolean>;
  abortControllersRef: AbortControllersRef;
  mismatchNotificationKeys: string[];
  constructor(props: Props) {
    super(props);
    this.gptTextAreaRef = React.createRef();
    this.isForceDontOpenPresetsRef = React.createRef();
    this.gptAssistantComponentRef = React.createRef();
    this.queueDataRef = React.createRef();
    this.queueDataRef.current = [];
    this.intervalRef = React.createRef();
    this.forceStopAllFlagRef = React.createRef();
    this.forceStopAllFlagRef.current = false;
    this.abortControllersRef = React.createRef();
    this.abortControllersRef.current = [];
    this.mismatchNotificationKeys = [];
  }
  componentWillReceiveProps(
    nextProps: Readonly<Props>,
    nextContext: any
  ): void {
    // Need to recolor nav in black/white depending on the bg color of the first component.
    const pageId = getCurrentPageId();
    const singlePageStatus = this.props.getPageLoadStatus(pageId);
    const singleWebsiteStatus = this.props.getSingleWebsiteLoadStatus(
      this.props.currentWebsite
    );
    if (
      (singlePageStatus === LoadStatus.LOADED ||
        singlePageStatus === LoadStatus.ERROR) &&
      singleWebsiteStatus === LoadStatus.LOADED
    ) {
      if (
        this.currentPageComponents &&
        this.currentPageComponents.data &&
        this.currentPageComponents.data.schema.length > 0 &&
        this.currentWebsite &&
        this.currentWebsite.nav &&
        this.currentWebsite.nav.settings &&
        this.currentWebsite.nav.settings.style &&
        this.currentWebsite.nav.settings.style.color
      ) {
        // These conditions are no more undefined when the component has been rendered and any component added.

        let currentNavColor = this.currentWebsite.nav.settings.style.color; //'black' or 'white'
        let currentFirstComponentBgTitle =
          this.currentPageComponents.data.schema[0].settings.background.color;
        let isFirstComponentBgDark = checkIfComponentHasDarkBg(
          currentFirstComponentBgTitle
        );

        let newNavColor = isFirstComponentBgDark ? "white" : "black";

        if (
          (isFirstComponentBgDark === true && currentNavColor === "black") ||
          (isFirstComponentBgDark === false && currentNavColor === "white")
        ) {
          // need to recolor the nav:
          this.props.changeWebsiteNavColor({
            currentWebsiteSubdomain: this.currentWebsite.subdomain,
            navColor: newNavColor,
          });
          this.props.toggleWebsiteNavEditionsDetected(true);
        }
      }
    }
  }

  componentWillUnmount(): void {
    if (
      !this.props.currentWebsite ||
      !this.props.currentWebsitePage ||
      this.currentPageIndex === undefined
    ) {
      return;
    }

    this.props.handleOnUnmount({
      intervalRef: this.intervalRef,
      forceStopAllFlagRef: this.forceStopAllFlagRef,
      queueDataRef: this.queueDataRef,
      currentWebsitePage: this.props.currentWebsitePage,
      currentWebsite: this.props.currentWebsite,
      currentPageIndex: this.currentPageIndex,
      abortControllersRef: this.abortControllersRef,
    });

    this.props.editFillTemplateData({
      websiteId: this.props.currentWebsite.id,
      newData: {
        status: "finished",
        isModalVisible: false,
        skipFooter: false,
        skipNav: false,
      },
    });
  }

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<{}>,
    snapshot?: any
  ): void {
    this.fetchSinglePage();

    const pageId = getCurrentPageId();
    const singlePageStatus = this.props.getPageLoadStatus(pageId);

    const { currentWebsitePage } = this.props;
    const prevPageId = _.get(prevProps, "currentWebsitePage.id");
    const currentPageId = _.get(currentWebsitePage, "id");

    if (
      singlePageStatus === LoadStatus.LOADED &&
      currentPageId !== prevPageId
    ) {
      this.props.changeWebsitePagesStateGlobalData({
        data: {
          pageBackup: _.cloneDeep(currentWebsitePage),
        },
      });
    }

    let isSaveButtonActive: boolean = false;
    isSaveButtonActive =
      this.props.websitesPages.websitePageNewEditionsDetected ||
      this.props.websites.isFooterEditionsDetected ||
      this.props.websites.isNavEditionsDetected ||
      this.props.websites.isCaptchaEditionsDetected ||
      this.props.websites.isPopupEditionsDetected;

    if (isSaveButtonActive) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
    const { currentWebsite } = this.props.getCurrentStoreData();
    const isModalVisible = _.get(currentWebsite, [
      "fillTemplateData",
      "isModalVisible",
    ]);
    const showPageModalFlag = _.get(currentWebsite, [
      "fillTemplateData",
      "showPageModalFlag",
    ]);
    if (isModalVisible && showPageModalFlag) {
      this.showFillTemplateModal();
      this.props.editFillTemplateData({
        websiteId: currentWebsite.id,
        newData: {
          showPageModalFlag: false,
          modalPage: "pickContent",
        },
      });
    }
  }

  state = {
    addPageComponentWindowVisible: false,
    newComponentPosition: 0,
    showSaveButtonSuccess: false,
    doesComponentClipboardHaveItem: false,
    firstComponentWasEdited: false, // mark as true to give the server a signal to make a fresh screenshot of the website page. search for markFirstComponentWasEditedAsTrue() uses to see when we mark the page as needs_screenshot=True (when a user changes content, bg options etc).
    gptInputValue: "",
    gptIsPopoverVisible: false,
    isFillTemplateModalVisible: false,
    isFillTemplateFormLoading: false,
    navHeight: 0,
    isVersionMismatchModalVisible: false,
    isMovePopoverVisible: false,
    isDeleteConfirmVisible: false,
    isPageContextDropdownVisible: false,
    isEditItemDataDrawerVisible: false,
  };

  showEditItemDataDrawer = () => {
    this.setState({
      isEditItemDataDrawerVisible: true,
    });
  };

  hideEditItemDataDrawer = () => {
    this.setState({
      isEditItemDataDrawerVisible: false,
    });
  };

  setIsPageContextDropdownVisible = (isPageContextDropdownVisible: boolean) => {
    this.setState({ isPageContextDropdownVisible });
  };

  setIsMovePopoverVisible = (isMovePopoverVisible: boolean) => {
    this.setState({ isMovePopoverVisible });
  };

  setIsDeleteConfirmVisible = (isDeleteConfirmVisible: boolean) => {
    this.setState({ isDeleteConfirmVisible });
  };

  setNavHeight = (height: number) => {
    this.setState({ navHeight: height });
  };

  setIsFillTemplateFormLoading = (isLoading: boolean) => {
    this.setState({ isFillTemplateFormLoading: isLoading });
  };

  showFillTemplateModal = () => {
    this.setState({
      isFillTemplateModalVisible: true,
    });
  };

  handleFillTemplateOk = () => {
    this.setState({
      isFillTemplateModalVisible: false,
    });
  };

  handleFillTemplateCancel = () => {
    this.setState({
      isFillTemplateModalVisible: false,
    });
    this.props.editFillTemplateData({
      websiteId: this.props.currentWebsite.id,
      newData: {
        isModalVisible: false,
      },
    });
  };

  gptSetValueAndResizeTextArea: SetValueAndResizeTextArea = (
    newValue,
    method
  ) => {
    const textAreaNode = this.gptTextAreaRef.current;
    const currentChat = this.props.getCurrentChatData(
      this.props.currentWebsitePage.id
    );
    if (currentChat.isLoading !== "none") return;
    if (textAreaNode) {
      textAreaNode.value =
        method === "replace" || !method
          ? newValue
          : textAreaNode.value + newValue;
      textAreaNode.style.height = "0";
      textAreaNode.style.height = textAreaNode.scrollHeight.toString() + "px";
    }
    if (method === "append") {
      this.setState((prevState: State) => ({
        gptInputValue: prevState.gptInputValue + newValue,
      }));
      return;
    }
    if (method === "prepend") {
      this.setState((prevState: State) => ({
        gptInputValue: newValue + prevState.gptInputValue,
      }));
      return;
    }
    this.setState({ gptInputValue: newValue });
  };

  gptFocusTextArea = (dontOpenPresets?: boolean) => {
    const textAreaNode = this.gptTextAreaRef.current;
    if (!textAreaNode) return;
    const value = textAreaNode.value;
    if (dontOpenPresets) {
      this.isForceDontOpenPresetsRef.current = true;
    }
    textAreaNode.value = "";
    textAreaNode.focus();
    textAreaNode.value = value;
    this.isForceDontOpenPresetsRef.current = false;
  };

  gptSetIsPopoverVisible = (isVisible: boolean) => {
    this.setState({ gptIsPopoverVisible: isVisible });
  };

  fetchSinglePage = () => {
    const pageId = getCurrentPageId();
    const subdomain = getCurrentSubdomain();
    const status = this.props.getPageLoadStatus(pageId);
    if (status !== LoadStatus.NOT_LOADED) return;
    this.props.setPageLoadStatus({
      pageId,
      status: LoadStatus.IN_PROGRESS,
    });
    const accessToken = this.props.auth.accessToken;
    axios
      .get(
        `${apiUrlBase}/api/v1/website_pages/${subdomain}/get_single_page?page_id=${pageId}`,
        {
          ...returnAuthHeaderForAJAX(accessToken),
        }
      )
      .then((response) => {
        const status = this.props.getPageLoadStatus(pageId);
        if (status !== LoadStatus.IN_PROGRESS) {
          return;
        }
        const websiteStatus = this.props.getSingleWebsiteLoadStatus({
          id: response.data.website,
        });
        if (websiteStatus === LoadStatus.DELETED) {
          return;
        }
        this.props.saveSinglePageInStore({
          page: response.data,
        });
        this.props.setPageLoadStatus({
          pageId,
          status: LoadStatus.LOADED,
        });
        this.props.changeWebsitePagesStateGlobalData({
          data: {
            pageBackup: _.cloneDeep(response.data),
          },
        });
      })
      .catch((error) => {
        this.props.setPageLoadStatus({
          pageId,
          status: LoadStatus.ERROR,
        });
        console.error(error.response);
        openNotification(
          "Error",
          "Couldn't fetch the page data.",
          "OK",
          "error",
          notificationDuration.long
        );
      });
  };

  componentDidMount(): void {
    const path = this.props.history.location.pathname;
    try {
      const appSection = getPathArray(path)[1];
      if (appSection !== "cms" && appSection !== "analytics") {
        localStorage.setItem(PATH_HISTORY_LS_KEY, path);
      }
    } catch (error) {
      console.error("Error while setting path history", error);
    }
    this.fetchSinglePage();
    const pageId = getCurrentPageId();
    const singlePageStatus = this.props.getPageLoadStatus(pageId);
    const singleWebsiteStatus = this.props.getSingleWebsiteLoadStatus(
      this.props.currentWebsite
    );
    if (singlePageStatus === LoadStatus.LOADED) {
      this.props.changeWebsitePagesStateGlobalData({
        data: {
          pageBackup: _.cloneDeep(_.get(this.props, "currentWebsitePage")),
        },
      });
    }
    if (singleWebsiteStatus === LoadStatus.LOADED) {
      this.props.changeWebsitesStateGlobalData({
        websiteBackup: _.cloneDeep(_.get(this.props, "currentWebsite")),
      });
    }
    if (
      (singlePageStatus === LoadStatus.LOADED ||
        singlePageStatus === LoadStatus.ERROR) &&
      singleWebsiteStatus === LoadStatus.LOADED
    ) {
      // If a user opens Editor screen from a direct URL it will render before the data is fetched, so this analytics even will not fire.
      // It's not a big deal, and OK now. But better to track each visit.
      let currentWebsite = getCurrentWebsite(this.props.websites.items);

      const isModalVisible = _.get(currentWebsite, [
        "fillTemplateData",
        "isModalVisible",
      ]);
      if (isModalVisible) {
        this.showFillTemplateModal();
      }

      let websitesPagesArray = this.props.websitesPages.items;
      let currentWebsitePageUrl = getCurrentWebsitePageUrl(
        currentWebsite,
        websitesPagesArray
      );
      if (currentWebsite) {
        // We can face "TypeError: Cannot read property 'subdomain' of undefined" if press the browser back button after changing subdomain in website settings.
        fireAnalyticsEvent.fireCrisp(CrispEvents.openEditorScreen, {
          subdomain: currentWebsite.subdomain,
          page_url: currentWebsitePageUrl,
        });
      }
    }

    // The interval is used to set user event only when the user data is loaded.
    const interval = setInterval(() => {
      const { user, auth } = this.props;
      if (user.data) {
        setUserEventsAsync(
          {
            [UserEvents.VisitedEditor]: new Date(),
          },
          auth.accessToken,
          user.data.events
        ).then((response) => {
          if (response) {
            this.props.saveUserEventsInStore(response.data);
          }
        });
        clearInterval(interval);
      }
    }, 1000);
  }

  markFirstComponentWasEditedAsTrue = (firstComponentWasEdited: boolean) => {
    // read the comment at 'state = {' to learn about this function
    if (firstComponentWasEdited) {
      this.setState({
        firstComponentWasEdited: true,
      });
    }
  };

  saveAllChanges = () => {
    // const dataToBackup = {};
    // if (websitesPages.websitePageNewEditionsDetected) {
    //   dataToBackup["has_page_components"] = true;
    //   dataToBackup["page_id"] = _.get(currentWebsitePage, "id");
    // }
    // if (websitesPages.websitePageNewNavEditionsDetected) {
    //   dataToBackup["has_page_settings"] = true;
    //   dataToBackup["page_id"] = _.get(currentWebsitePage, "id");
    // }
    // if (websites.isNavEditionsDetected) {
    //   dataToBackup["has_website_nav"] = true;
    // }
    // if (websites.isFooterEditionsDetected) {
    //   dataToBackup["has_website_footer"] = true;
    // }
    // if (websites.isCaptchaEditionsDetected) {
    //   dataToBackup["has_recaptcha"] = true;
    // }
    // if (websites.isPopupEditionsDetected) {
    //   dataToBackup["has_popups"] = true;
    // }
    // try {
    //   await this.props.saveWebsiteBackup(dataToBackup);
    // } catch (e) {
    //   console.error(_.get(e, "response.data"));
    // }
    // this.savePageData();
  };

  savePageData = (isVersionIgnored?: boolean) => {
    this.props.changeWebsitesStateGlobalData({
      isWebsiteChangesWaitingForServer: true,
    });

    if (process.env.NODE_ENV !== "development") {
      try {
        this.props.saveWebsiteBackup("page");
        this.props.saveWebsiteBackup("website");
      } catch (e) {
        console.error(_.get(e, "response.data"));
      }
    }

    const { currentWebsite, currentWebsitePage } =
      this.props.getCurrentStoreData();
    const { websites, websitesPages } = this.props;

    const data = {
      temp_data: {
        page_id: currentWebsitePage.id,
        page_url: currentWebsitePage.url,
        is_published: currentWebsitePage.is_published,
        is_version_ignored: isVersionIgnored,
      },
      page_data: {},
      website_data: {},
    };
    if (this.props.websitesPages.websitePageNewEditionsDetected) {
      data["page_data"]["page_components"] = currentWebsitePage.page_components;
      const {
        first_page_title,
        first_page_subtitle,
        hero_image_url,
        hero_image_uuid,
      } = getMetaDataFromComponentsArray(currentWebsitePage.page_components);
      data["page_data"]["first_page_title"] = first_page_title;
      data["page_data"]["first_page_subtitle"] = first_page_subtitle;
      data["page_data"]["hero_image_url"] = hero_image_url;
      data["page_data"]["hero_image_uuid"] = hero_image_uuid;
      this.props.changePageItemGlobalData({
        pageId: this.props.currentWebsitePage.id,
        data: {
          first_page_title: data["page_data"]["first_page_title"],
          first_page_subtitle: data["page_data"]["first_page_subtitle"],
          hero_image_url: data["page_data"]["hero_image_url"],
          hero_image_uuid: data["page_data"]["hero_image_uuid"],
        },
      });
    }
    if (websitesPages.websitePageNewNavEditionsDetected) {
      data["page_data"]["is_nav_hidden"] = currentWebsitePage.is_nav_hidden;
    }
    if (websites.isNavEditionsDetected) {
      data["website_data"]["nav"] = currentWebsite.nav;
    }
    if (websites.isFooterEditionsDetected) {
      data["website_data"]["footer"] = currentWebsite.footer;
    }
    if (websites.isCaptchaEditionsDetected) {
      data["website_data"]["recaptcha"] = currentWebsite.recaptcha;
    }
    if (websites.isPopupEditionsDetected) {
      data["website_data"]["popups"] = currentWebsite.popups;
    }

    if (!checkIfObjectEmpty(data["page_data"])) {
      data["temp_data"]["page_update_version"] =
        currentWebsitePage.update_version;
    }
    if (!checkIfObjectEmpty(data["website_data"])) {
      data["temp_data"]["website_update_version"] =
        currentWebsite.update_version;
    }

    let accessToken = this.props.auth.accessToken;
    let apiUrl = `${apiUrlBase}/api/v1/website_pages/${currentWebsite.subdomain}/save_page_editor_changes`;

    axios
      .post(apiUrl, data, { ...returnAuthHeaderForAJAX(accessToken) })
      .then((response) => {
        const responseData = response.data;
        fireAnalyticsEvent.fireCrisp(CrispEvents.savePageEditions, {
          website: currentWebsite.subdomain,
          page_url: currentWebsitePage.url,
        });
        this.props.changeWebsitesStateGlobalData({
          isNavEditionsDetected: false,
          isFooterEditionsDetected: false,
          isCaptchaEditionsDetected: false,
          isPopupEditionsDetected: false,
        });
        this.props.changeWebsitePagesStateGlobalData({
          data: {
            websitePageNewEditionsDetected: false,
            websitePageNewNavEditionsDetected: false,
          },
        });
        this.props.saveToLocalBackup("page");
        this.props.saveToLocalBackup("website");
        this.launchSuccessfulSaveAnimation();

        if ("page_update_version" in responseData) {
          this.props.changePageItemGlobalData({
            pageId: this.props.currentWebsitePage.id,
            data: {
              update_version: responseData["page_update_version"],
            },
          });
        }
        if ("website_update_version" in responseData) {
          this.props.changeWebsiteItemGlobalData({
            websiteId: currentWebsite.id,
            data: {
              update_version: responseData["website_update_version"],
            },
          });
        }
      })
      .catch((error) => {
        if (_.get(error, "response.data.error_type") === "version_mismatch") {
          this.setState({ isVersionMismatchModalVisible: true });
        }
        if (error.response) {
          let errorData = error.response.data;
          handleBadWebsiteError(errorData);
          if (errorData.page_components !== undefined) {
            let message = errorData.page_components;
            let errorObjectKey = getErrorKey(errorData);
            let errorObjectValue = getErrorValue(errorData, errorObjectKey);
            fireAnalyticsEvent.fireCrisp(
              CrispEvents.savePageEditionsError,
              {
                error_type: errorObjectKey,
                error_message: errorObjectValue,
                type: "Page data",
                website: currentWebsite.subdomain,
              },
              true
            );
            openNotification(
              "Internal error",
              'Error message: "' +
                message +
                '". This should not have happened. Sorry. Please contact us.',
              "OK",
              "error"
            );
          }
          if (errorData.detail !== undefined) {
            let message = errorData.detail;
            openNotification(
              "Server error",
              'Error message: "' +
                message +
                '". This should not have happened. Please contact us.',
              "OK",
              "error"
            );
          }
          if (errorData.locked !== undefined) {
            let message = errorData.locked;
            openNotification("Denied", message, "OK", "warn");
          }
        } else {
          openNotification(
            "Error :(",
            "There was an error during saving the changes. Please re-check your Internet connection and try again.",
            "OK",
            "warn",
            999
          );
          openNotification(
            "If this doesn't help",
            "To save your changes, open the browser console.",
            "Thanks",
            "warn",
            999
          );
          console.info(
            "This log contains your changes. Kindly email it to us if you want to save the changes you made."
          );
          console.log(JSON.stringify(currentWebsitePage.page_components));
          console.info("We are sorry for the incident! 🙏");
        }
      })
      .finally(() => {
        this.props.changeWebsitesStateGlobalData({
          isWebsiteChangesWaitingForServer: false,
        });
      });
  };

  launchSuccessfulSaveAnimation = () => {
    this.setState({
      showSaveButtonSuccess: true,
    });

    setTimeout(() => {
      this.setState({
        showSaveButtonSuccess: false,
      });
    }, 1000);
  };

  handleCloseAddComponent = () => {
    this.setState({
      addPageComponentWindowVisible: false,
    });
  };
  openAddNewComponent = (position: number) => {
    this.setState({
      addPageComponentWindowVisible: true,
      newComponentPosition: position,
    });
  };
  generator = new generateContentDataObject();

  saveFooterInServer = () => {
    this.props.toggleWaitingForResponseOnWebsiteFooterEditions(true);

    let currentWebsite = getCurrentWebsite(this.props.websites.items);

    let accessToken = this.props.auth.accessToken;
    let apiUrl =
      api.websites.updateWebsite.prefix +
      currentWebsite.subdomain +
      api.websites.updateWebsite.postfix;

    axios
      .patch(
        apiUrl,
        { footer: currentWebsite.footer },
        { ...returnAuthHeaderForAJAX(accessToken) }
      )
      .then(() => {
        // Tell a user that the operation is successful.

        // let message = 'Website footer has been successfully saved.';
        fireAnalyticsEvent.fireCrisp(CrispEvents.savePageEditions, {
          type: "Website footer",
          website: this.props.currentWebsite.subdomain,
        });

        // openNotification('Done', message, 'Close', 'success', 5);
        this.launchSuccessfulSaveAnimation();
      })
      .catch((error) => {
        // handle error
        if (error.response) {
          let errorData = error.response.data;

          let errorObjectKey = getErrorKey(errorData);
          let errorObjectValue = getErrorValue(errorData, errorObjectKey);

          fireAnalyticsEvent.fireCrisp(
            CrispEvents.savePageEditionsError,
            {
              error_type: errorObjectKey,
              error_message: errorObjectValue,
              type: "Website footer",
              website: currentWebsite.subdomain,
            },
            true
          );

          handleBadWebsiteError(errorData);
          if (errorData.not_pro !== undefined) {
            let message = errorData.not_pro;
            openNotification("Denied", message, "OK", "warn");
          }

          if (errorData.locked !== undefined) {
            let message = errorData.locked;
            openNotification("Denied", message, "OK", "warn");
          }

          if (errorData.detail !== undefined) {
            let message = errorData.detail;

            // This happens when user tries to change a website which doesn't exist or doesn't belong to the user.
            openNotification(
              "Server error",
              'Error message: "' +
                message +
                '". This should not have happened. Please contact us.',
              "OK",
              "error"
            );
          }
        }
      })
      .then((response) => {
        // always executed
        this.props.toggleWebsiteFooterEditionsDetected(false);
        this.props.toggleWaitingForResponseOnWebsiteFooterEditions(false);
      });
  };

  saveNavInServer = () => {
    this.props.toggleWaitingForResponseOnWebsiteNavEditions(true);

    let currentWebsite = getCurrentWebsite(this.props.websites.items);

    let accessToken = this.props.auth.accessToken;
    let apiUrl =
      api.websites.updateWebsite.prefix +
      currentWebsite.subdomain +
      api.websites.updateWebsite.postfix;

    axios
      .patch(
        apiUrl,
        { nav: currentWebsite.nav },
        { ...returnAuthHeaderForAJAX(accessToken) }
      )
      .then(() => {
        this.launchSuccessfulSaveAnimation();
      })
      .catch((error) => {
        // handle error
        if (error.response) {
          let errorData = error.response.data;

          handleBadWebsiteError(errorData);
          if (errorData.not_pro !== undefined) {
            let message = errorData.not_pro;
            openNotification("Denied", message, "OK", "warn");
          }

          if (errorData.locked !== undefined) {
            let message = errorData.locked;
            openNotification("Denied", message, "OK", "warn");
          }

          if (errorData.detail !== undefined) {
            let message = errorData.detail;

            // This happens when user tries to change a website which doesn't exist or doesn't belong to the user.
            openNotification(
              "Server error",
              'Error message: "' +
                message +
                '". This should not have happened. Please contact us.',
              "OK",
              "error"
            );
          }
        }
      })
      .then((response) => {
        // always executed
        this.props.toggleWebsiteNavEditionsDetected(false);
        this.props.toggleWaitingForResponseOnWebsiteNavEditions(false);
      });
  };

  currentPageIndex: number; //needed to change the redux store when adding a new component. at the beginning it is undefined (we use 0). after the page is rendered, we find out this index and save here.

  // declare currentWebsite and currentPageComponents to use later.
  currentWebsite: any = undefined;
  currentPageComponents: any = undefined;

  render() {
    let currentWebsiteSubdomain = getCurrentWebsiteSubdomain(
      this.props.websites.items
    ); // used below for saving data in the server
    let currentWebsitePageUrl: string; // used below for saving data in the server
    // let currentPageComponents: any; // used below for display "Add component"

    const gptInputObject: GptInputObject = {
      inputValue: this.state.gptInputValue,
      textAreaRef: this.gptTextAreaRef,
      setInputValue: this.gptSetValueAndResizeTextArea,
      focusTextArea: this.gptFocusTextArea,
      isForceDontOpenPresetsRef: this.isForceDontOpenPresetsRef,
    };

    const gptPopoverObject: GptPopoverObject = {
      isPopoverVisible: this.state.gptIsPopoverVisible,
      setIsPopoverVisible: this.gptSetIsPopoverVisible,
    };

    const onGptClick: OnGptClick = (componentId, setValue, mode) => {
      if (mode) {
        this.props.setMode({
          pageId: this.props.currentWebsitePage.id,
          mode,
        });
      }
      const { setIsPopoverVisible } = gptPopoverObject;
      const { setInputValue } = gptInputObject;
      setIsPopoverVisible(true);
      if (setValue) {
        setInputValue(`${componentId}: `);
      }
    };

    const displayAddComponentButton = () => {
      if (checkIfPageHasComponents(this.currentPageComponents)) {
        return null;
      }
      const copiedComponentJSON = _.get(this.props.user, "clipboard.component");
      return (
        <div
          style={{
            padding: "128px 64px",
            background: "#FAFAFA",
            marginBottom: !!slugParam ? -8 : 0,
          }}
        >
          <Empty description={null}>
            {!slugParam && (
              <div
                style={{
                  display: "flex",
                  gap: 10,
                  justifyContent: "center",
                  marginTop: -6,
                }}
              >
                <Button
                  type="primary"
                  onClick={() => {
                    window.posthog.capture(PosthogEvents.CLICK_ADD_COMPONENT);
                    this.openAddNewComponent(0);
                  }}
                  className="editor__cta-button-new"
                >
                  Add component
                </Button>
                {copiedComponentJSON && (
                  <Button
                    type="primary"
                    ghost
                    onClick={() => {
                      this.props.pasteCopiedComponent({
                        copiedComponentJSON,
                        indexToPlace: 0,
                        currentPageIndex: this.currentPageIndex,
                      });
                    }}
                    className="editor__cta-button-new"
                  >
                    <ClipboardIcon size={14} />
                    Paste component
                  </Button>
                )}
              </div>
            )}
          </Empty>
        </div>
      );
    };

    let displayPageScheme = () => {
      const pageId = getCurrentPageId();

      const singlePageStatus = this.props.getPageLoadStatus(pageId);
      if (
        singlePageStatus !== LoadStatus.LOADED &&
        singlePageStatus !== LoadStatus.ERROR
      ) {
        return (
          <div style={{ marginTop: "calc(50vh - 81px)" }}>
            <SpinnerBox text="Rendering page components..." />
          </div>
        );
      }

      const singleWebsiteStatus = this.props.getSingleWebsiteLoadStatus(
        this.props.currentWebsite
      );
      if (singleWebsiteStatus !== LoadStatus.LOADED) {
        return (
          <div style={{ marginTop: "calc(50vh - 81px)" }}>
            <SpinnerBox text="Loading global website data..." />
          </div>
        );
      }

      if (!this.props.pageComponentCategories.dataFetched) {
        return (
          <div style={{ marginTop: "calc(50vh - 81px)" }}>
            <SpinnerBox text="Loading additional data..." />
          </div>
        );
      } else {
        this.currentWebsite = getCurrentWebsite(this.props.websites.items);

        if (this.currentWebsite === undefined) {
          // If no such website, offer to go to the main dashboard screen.
          return (
            <div style={{ paddingTop: "40px", paddingBottom: "40px" }}>
              <Empty description={<span>Website not found</span>}>
                <Link to="/">
                  <Button type="primary">Back to your websites</Button>
                </Link>
              </Empty>
            </div>
          );
        }

        // After we check the website, check the page:
        let websitesPagesArray = this.props.websitesPages.items;
        currentWebsitePageUrl = getCurrentWebsitePageUrl(
          this.currentWebsite,
          websitesPagesArray
        );
        let currentWebsitePage = websitesPagesArray.find(
          (websitePage: any) =>
            websitePage.url === currentWebsitePageUrl &&
            websitePage.website === this.currentWebsite.id
        );

        if (currentWebsitePage === undefined) {
          // If no such website page, offer to go to the website pages list.
          return (
            <div style={{ paddingTop: "40px", paddingBottom: "40px" }}>
              <Empty description={<span>Website page not found</span>}>
                <Link to={"/" + this.currentWebsite.subdomain + "/pages"}>
                  <Button type="primary">Back to pages</Button>
                </Link>
              </Empty>
            </div>
          );
        }
        this.currentPageIndex = websitesPagesArray.indexOf(currentWebsitePage);
        this.currentPageComponents = currentWebsitePage.page_components; //an object containing everything about the page content.
        let componentsArray = _.get(
          this.currentPageComponents,
          "data.schema",
          []
        );
        let currentWebsiteCopy = _.cloneDeep(this.currentWebsite);
        const pageDynamicData = this.props.getPageDynamicData({
          page: this.props.currentWebsitePage,
        });
        const slugParam = getUrlParameter("slug");
        if (slugParam) {
          if (
            !pageDynamicData.slugs.includes(slugParam) &&
            !pageDynamicData.allSlugs.includes(slugParam)
          ) {
            const newUrl = new URL(window.location.href);
            return <Redirect to={newUrl.pathname} />;
          }
          componentsArray = _.cloneDeep(componentsArray);
          componentsArray = addPreviewFlag(componentsArray);
          const sourceDict = pageDynamicData.items.find((item) => {
            return item[pageDynamicData.slugField] === slugParam;
          });
          console.log("sourceDict: ", sourceDict);
          componentsArray = replaceDynamicVariables(
            sourceDict,
            componentsArray
          );
          currentWebsiteCopy = replaceDynamicVariables(
            sourceDict,
            currentWebsiteCopy
          );
        }

        let components = componentsArray.map(
          (componentItem: any, componentKey: number) => {
            // we want to find the component category in the categories list to pass the category info (title)
            let categoriesArray = this.props.pageComponentCategories.items;
            let currentComponentCategoryId = componentItem.category;
            let currentComponentCategory = categoriesArray.find(
              (category: any) => {
                return currentComponentCategoryId === category.id;
              }
            );

            // display the components
            const editorComponentKey = `${currentWebsitePageUrl || "home"}-${
              componentItem.id
            }`;
            return (
              <li className="editor__component" key={editorComponentKey}>
                <PageComponent
                  slugParam={slugParam}
                  pasteCopiedWebsitePageComponent={
                    this.props.pasteCopiedWebsitePageComponent
                  }
                  toggleWaitingForCommonWebsiteUpdate={
                    this.props.toggleWaitingForCommonWebsiteUpdate
                  }
                  removeWebsiteFormIntegration={
                    this.props.removeWebsiteFormIntegration
                  }
                  openAddNewComponent={this.openAddNewComponent}
                  componentCategory={currentComponentCategory.title} // e.g. "header", "cta-button".
                  componentItem={componentItem}
                  componentKey={componentKey}
                  componentsArray={componentsArray}
                  websites={this.props.websites}
                  formIntegrations={this.props.formIntegrations}
                  auth={this.props.auth}
                  user={this.props.user}
                  history={this.props.history}
                  markFirstComponentWasEditedAsTrue={
                    this.markFirstComponentWasEditedAsTrue
                  }
                  changeWebsitePageComponentVisibility={
                    this.props.changeWebsitePageComponentVisibility
                  }
                  currentPageIndex={this.currentPageIndex}
                  currentWebsite={this.currentWebsite}
                  changeWebsitePageComponentBackgroundColor={
                    this.props.changeWebsitePageComponentBackgroundColor
                  }
                  changeWebsitePageComponentBackgroundImage={
                    this.props.changeWebsitePageComponentBackgroundImage
                  }
                  changeWebsitePageComponentBackgroundImageOverlayOpacity={
                    this.props
                      .changeWebsitePageComponentBackgroundImageOverlayOpacity
                  }
                  changeWebsitePageComponentPaddingTop={
                    this.props.changeWebsitePageComponentPaddingTop
                  }
                  changeWebsitePageComponentPaddingBottom={
                    this.props.changeWebsitePageComponentPaddingBottom
                  }
                  editWebsitePageSchemeToggleWaitingForServer={
                    this.props.editWebsitePageSchemeToggleWaitingForServer
                  }
                  toggleNewWebsitePageEditionsDetected={
                    this.props.toggleNewWebsitePageEditionsDetected
                  }
                  moveWebsitePageComponent={this.props.moveWebsitePageComponent}
                  deleteWebsitePageComponent={
                    this.props.deleteWebsitePageComponent
                  }
                  changeWebsitePageComponentContent={
                    this.props.changeWebsitePageComponentContent
                  }
                  toggleWaitingForConnectPaymentIntegration={
                    this.props.toggleWaitingForConnectPaymentIntegration
                  }
                  toggleWaitingForChangePaymentIntegrationProductsArray={
                    this.props
                      .toggleWaitingForChangePaymentIntegrationProductsArray
                  }
                  toggleWaitingForEditPaymentIntegrationProductDetails={
                    this.props
                      .toggleWaitingForEditPaymentIntegrationProductDetails
                  }
                  toggleWaitingForConfigurePaymentIntegration={
                    this.props.toggleWaitingForConfigurePaymentIntegration
                  }
                  saveWebsiteNewFormIntegrationInState={
                    this.props.saveWebsiteNewFormIntegrationInState
                  }
                  toggleWaitingForResponseOnWebsiteFormIntegrationAdd={
                    this.props
                      .toggleWaitingForResponseOnWebsiteFormIntegrationAdd
                  }
                  saveImageInfoInDB={this.props.saveImageInfoInDB}
                  removeImageFromDB={this.props.removeImageFromDB}
                  changeStripeSecretKey={this.props.changeStripeSecretKey}
                  changeStripePublicKey={this.props.changeStripePublicKey}
                  changeStripeCheckoutProductsArray={
                    this.props.changeStripeCheckoutProductsArray
                  }
                  saveWebsiteDataInStore={this.props.saveWebsiteDataInStore}
                  toggleIsPageNavHidden={this.props.toggleIsPageNavHidden}
                  toggleIsPageFooterHidden={this.props.toggleIsPageFooterHidden}
                  currentWebsitePage={currentWebsitePage}
                  gptInputObject={gptInputObject}
                  gptPopoverObject={gptPopoverObject}
                  onGptClick={onGptClick}
                  gptAssistantComponentRef={this.gptAssistantComponentRef}
                  queueDataRef={this.queueDataRef}
                  intervalRef={this.intervalRef}
                  forceStopAllFlagRef={this.forceStopAllFlagRef}
                  abortControllersRef={this.abortControllersRef}
                  navHeight={this.state.navHeight}
                />
              </li>
            );
          }
        );

        let customColorsActiveClassnames = applyCustomColorsClassnames(
          this.currentWebsite
        );

        return (
          // the .comps class is needed to increase the power of the page components styles. Ant.design styles sometime beat them.
          /*// The .style-blue-1 class is needed for styling. It will be dynamical when we create color tuning.*/
          <div>
            {/* {
                <DisplayBadWebsiteOverlay
                  website={this.currentWebsite}
                  history={this.props.history}
                />
              } */}
            {/* <AvailableGlobalProps /> */}
            <div className="editor__wrapper" id={"capture_area"}>
              <div className="comps">
                <div
                  className={
                    this.currentWebsite.color_classname +
                    " " +
                    customColorsActiveClassnames
                  }
                >
                  <WebsiteNav
                    slugParam={slugParam}
                    currentWebsite={
                      slugParam ? currentWebsiteCopy : this.currentWebsite
                    }
                    componentsArray={componentsArray}
                    saveNavInServer={this.props.saveWebsiteNavInServer}
                    isBlogNavEdited={false}
                    currentWebsitePage={currentWebsitePage}
                    navEditionFieldsVisible={this.props.navEditionFieldsVisible}
                    showNavEditionFieldsDrawer={
                      this.props.showNavEditionFieldsDrawer
                    }
                    hideNavEditionFieldsDrawer={
                      this.props.hideNavEditionFieldsDrawer
                    }
                    displayNavOrFooterEditionBox={
                      this.props.displayNavOrFooterEditionBox
                    }
                    blogs={this.props.blogs}
                    saveBlogNavInState={this.props.saveBlogNavInState}
                    saveWebsiteNavInState={this.props.saveWebsiteNavInState}
                    toggleBlogNavEditionsDetected={
                      this.props.toggleBlogNavEditionsDetected
                    }
                    toggleWebsiteNavEditionsDetected={
                      this.props.toggleWebsiteNavEditionsDetected
                    }
                    onGptClick={onGptClick}
                    isWebsiteNav={true}
                    gpt={this.props.gpt}
                    gptAssistantComponentRef={this.gptAssistantComponentRef}
                    user={this.props.user}
                    currentPageIndex={this.currentPageIndex}
                    queueDataRef={this.queueDataRef}
                    intervalRef={this.intervalRef}
                    forceStopAllFlagRef={this.forceStopAllFlagRef}
                    abortControllersRef={this.abortControllersRef}
                    setNavHeight={this.setNavHeight}
                  />

                  {/*// Render the page components*/}
                  <ul className="editor__components">
                    {components}
                    <PopupComponents
                      currentPageIndex={this.currentPageIndex}
                      saveImageInfoInDB={this.props.saveImageInfoInDB}
                      removeImageFromDB={this.props.removeImageFromDB}
                      saveWebsiteDataInStore={this.props.saveWebsiteDataInStore}
                    />
                  </ul>
                  {displayAddComponentButton()}
                  <WebsiteFooter
                    slugParam={slugParam}
                    currentWebsite={
                      slugParam ? currentWebsiteCopy : this.currentWebsite
                    }
                    saveFooterInServer={this.props.saveWebsiteFooterInServer}
                    isBlogFooterEdited={false}
                    blogs={this.props.blogs}
                    footerEditionFieldsVisible={
                      this.props.footerEditionFieldsVisible
                    }
                    saveBlogFooterInState={this.props.saveBlogFooterInState}
                    saveWebsiteFooterInState={
                      this.props.saveWebsiteFooterInState
                    }
                    showFooterEditionFieldsDrawer={
                      this.props.showFooterEditionFieldsDrawer
                    }
                    hideFooterEditionFieldsDrawer={
                      this.props.hideFooterEditionFieldsDrawer
                    }
                    displayNavOrFooterEditionBox={
                      this.props.displayNavOrFooterEditionBox
                    }
                    toggleBlogFooterEditionsDetected={
                      this.props.toggleBlogFooterEditionsDetected
                    }
                    toggleWebsiteFooterEditionsDetected={
                      this.props.toggleWebsiteFooterEditionsDetected
                    }
                    onGptClick={onGptClick}
                    isWebsiteFooter={true}
                    gpt={this.props.gpt}
                    gptAssistantComponentRef={this.gptAssistantComponentRef}
                    user={this.props.user}
                    currentWebsitePage={currentWebsitePage}
                    currentPageIndex={this.currentPageIndex}
                    queueDataRef={this.queueDataRef}
                    intervalRef={this.intervalRef}
                    forceStopAllFlagRef={this.forceStopAllFlagRef}
                    abortControllersRef={this.abortControllersRef}
                  />
                </div>
              </div>
            </div>
            <PopupMask />
            <Modal
              title={
                fillTemplateModalPage === "form"
                  ? "Tell AI something about your product"
                  : "Choose content type"
              }
              visible={this.state.isFillTemplateModalVisible}
              onOk={this.handleFillTemplateOk}
              onCancel={() => {
                const templateSubdomain = _.get(
                  this.currentWebsite,
                  "fillTemplateData.templateSubdomain"
                );
                window.posthog.capture(PosthogEvents.CLOSE_AI_TEMPLATE_MODAL, {
                  website_id: this.currentWebsite.id,
                  template_subdomain: templateSubdomain,
                });
                this.handleFillTemplateCancel();
              }}
              centered
              width={"auto"}
              footer={
                fillTemplateModalPage === "form" ? (
                  <GenerateButton
                    isLoading={this.state.isFillTemplateFormLoading}
                  >
                    Generate
                  </GenerateButton>
                ) : null
              }
              maskClosable={false}
              zIndex={1021}
            >
              <FillTemplateModalContent
                handleFillTemplateCancel={this.handleFillTemplateCancel}
                queueDataRef={this.queueDataRef}
                intervalRef={this.intervalRef}
                forceStopAllFlagRef={this.forceStopAllFlagRef}
                setIsFillTemplateFormLoading={this.setIsFillTemplateFormLoading}
                isLoading={this.state.isFillTemplateFormLoading}
                abortControllersRef={this.abortControllersRef}
              />
            </Modal>
          </div>
        );
      }
    };

    let isSaveButtonActive: boolean = false;
    isSaveButtonActive =
      this.props.websitesPages.websitePageNewEditionsDetected ||
      this.props.websites.isFooterEditionsDetected ||
      this.props.websites.isNavEditionsDetected ||
      this.props.websites.isCaptchaEditionsDetected ||
      this.props.websites.isPopupEditionsDetected ||
      this.props.websitesPages.websitePageNewNavEditionsDetected;

    let isSaveButtonLoading: boolean = false;
    isSaveButtonLoading =
      this.props.websites.isWebsiteChangesWaitingForServer ||
      this.props.websites.isSaveButtonLoading;

    // startOnboardingTour('add_component', this.props.user);
    const fillTemplateProgress = _.get(
      this.currentWebsite,
      "fillTemplateData.status"
    );
    const fillTemplateModalPage = _.get(
      this.currentWebsite,
      "fillTemplateData.modalPage"
    );

    const hasComponents = checkIfPageHasComponents(this.currentPageComponents);
    const renderButton = () => {
      const saveAnumationJsx = (
        <div className="editor__save_button_tick">
          <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
        </div>
      );

      const isFreeNew = this.props.isUserFreeNew();

      if (isFreeNew && !isSaveButtonActive) {
        return (
          <>
            {this.state.showSaveButtonSuccess && saveAnumationJsx}
            <Button
              type="primary"
              className="editor__save_button-new is-ghost"
              onClick={() => {
                if (this.props.currentWebsitePage.is_published) {
                  this.props.previewPage(this.props.currentWebsitePage.id);
                  return;
                }
                this.props.publishPage(
                  true,
                  this.props.currentWebsitePage.url,
                  this.props.currentWebsite,
                  null,
                  () => {
                    this.props.previewPage(this.props.currentWebsitePage.id);
                  }
                );
              }}
              style={{
                gap: 6,
              }}
              disabled={
                this.props.websitesPages.isWaitingForPublishPageResponse
              }
            >
              {this.props.websitesPages.isWaitingForPublishPageResponse && (
                <LoaderAnimated size={14} />
              )}
              Preview
            </Button>
          </>
        );
      }
      const isPublished = _.get(this.props.currentWebsitePage, "is_published");
      if (!isFreeNew && !isSaveButtonActive && !isPublished) {
        return (
          <>
            {this.state.showSaveButtonSuccess && saveAnumationJsx}
            <Button
              className="editor__save_button-new"
              type="primary"
              onClick={() => {
                this.props.publishPage(
                  true,
                  this.props.currentWebsitePageUrl,
                  this.props.currentWebsite,
                  null,
                  () => {
                    const fullPageUrl = getFullPageUrl(
                      this.props.currentWebsite,
                      formatToURLPath(this.props.currentWebsitePageUrl)
                    );
                    this.launchSuccessfulSaveAnimation();
                    openNotification(
                      "Done",
                      <span>
                        The page has been published. It's now visible to anyone
                        by{" "}
                        <a
                          target="_blank"
                          href={addNoCacheParamToURL(fullPageUrl)}
                        >
                          this URL
                        </a>
                      </span>,
                      "Close",
                      "success",
                      notificationDuration.medium
                    );
                  }
                );
              }}
              disabled={
                this.props.websitesPages.isWaitingForPublishPageResponse
              }
              style={{
                gap: 6,
              }}
            >
              {this.props.websitesPages.isWaitingForPublishPageResponse && (
                <LoaderAnimated size={14} />
              )}
              Publish
            </Button>
          </>
        );
      }
      if (!isFreeNew && !isSaveButtonActive && isPublished) {
        return (
          <>
            {this.state.showSaveButtonSuccess && saveAnumationJsx}
            <Button
              type="primary"
              className="editor__save_button-new is-ghost"
              onClick={() => {
                this.props.previewPage(this.props.currentWebsitePage.id);
              }}
              style={{
                gap: 6,
              }}
            >
              Preview
            </Button>
          </>
        );
      }
      return (
        <>
          {this.state.showSaveButtonSuccess && saveAnumationJsx}

          <Button
            className={classNames("editor__save_button-new", {
              "is-hidden": !isSaveButtonActive,
            })}
            onClick={() => {
              this.savePageData();
              const hasUnsavedAiGeneratedContent = _.get(
                this.currentWebsite,
                "fillTemplateData.hasUnsavedAiGeneratedContent"
              );
              if (hasUnsavedAiGeneratedContent) {
                const templateSubdomain = _.get(
                  this.currentWebsite,
                  "fillTemplateData.templateSubdomain"
                );
                window.posthog.capture(
                  PosthogEvents.SAVE_AI_GENERATED_CONTENT,
                  {
                    website_id: this.currentWebsite.id,
                    template_subdomain: templateSubdomain,
                  }
                );
                this.props.editFillTemplateData({
                  websiteId: this.currentWebsite.id,
                  newData: {
                    hasUnsavedAiGeneratedContent: false,
                  },
                });
              }
            }}
            title={
              isSaveButtonActive
                ? "Click to save the changes"
                : "No changes to save"
            }
            htmlType="button"
            type="primary"
            disabled={isSaveButtonLoading}
            style={{
              gap: 6,
            }}
          >
            {isSaveButtonLoading && <LoaderAnimated size={14} />}
            Save changes
          </Button>
        </>
      );
    };

    const slugParam = getUrlParameter("slug");
    const pageId = getCurrentPageId();
    const singlePageStatus = this.props.getPageLoadStatus(pageId);
    const myOtherWebsites = this.props.websites.items.filter((website) => {
      return website.id !== _.get(this.props.currentWebsite, "id");
    });

    return (
      <div
        className={classNames(
          `editor ${getCustomStyleClassNames(this.props.currentWebsite)}`,
          {
            "has-slug-param": !!slugParam,
            "no-components": !checkIfPageHasComponents(
              this.currentPageComponents
            ),
            "is-fill-template-in-progress":
              fillTemplateProgress === "inProgress",
          }
        )}
      >
        <Prompt
          when={isSaveButtonActive}
          message={(location, action) => {
            const currentPath = this.props.history.location.pathname;
            const newPath = location.pathname;
            if (currentPath === newPath) {
              return true;
            }

            return "You have unsaved page changes. Are you sure you want to leave?";
          }}
        />

        {displayPageScheme()}

        <AddPageComponent
          meta={this.props.meta}
          pageComponents={this.props.pageComponents}
          pageComponentCategories={this.props.pageComponentCategories}
          currentPageComponents={this.currentPageComponents}
          user={this.props.user}
          handleCloseAddComponent={this.handleCloseAddComponent}
          history={this.props.history}
          isAddComponentWindowVisible={this.state.addPageComponentWindowVisible}
          newComponentPosition={this.state.newComponentPosition}
          currentPageIndex={this.currentPageIndex}
          addWebsitePageComponent={this.props.addWebsitePageComponent}
          pasteCopiedWebsitePageComponent={
            this.props.pasteCopiedWebsitePageComponent
          }
          toggleNewWebsitePageEditionsDetected={
            this.props.toggleNewWebsitePageEditionsDetected
          }
          currentWebsiteSubdomain={currentWebsiteSubdomain}
          currentWebsitePageUrl={currentWebsitePageUrl}
          doesComponentClipboardHaveItem={
            this.state.doesComponentClipboardHaveItem
          }
          auth={this.props.auth}
          changeComponentGlobalData={this.props.changeComponentGlobalData}
          websitesPages={this.props.websitesPages}
          changeWebsitePagesStateGlobalData={
            this.props.changeWebsitePagesStateGlobalData
          }
        />

        <PageBottomBar
          isHidden={
            !this.props.currentWebsitePage ||
            singlePageStatus !== LoadStatus.LOADED
          }
          isButtonHidden={
            !hasComponents && !isSaveButtonActive && !isSaveButtonLoading
          }
          buttons={renderButton()}
          fillTemplateProgress={fillTemplateProgress}
          isSaveButtonActive={isSaveButtonActive}
          isSaveButtonLoading={isSaveButtonLoading}
          iconButtons={[
            {
              tooltip: "",
              icon: <Ellipsis size={16} />,
              buttonJsx: (
                <Dropdown
                  placement="topCenter"
                  align={{ offset: [0, -16] }}
                  transitionName=""
                  visible={this.state.isPageContextDropdownVisible}
                  onVisibleChange={(flag) => {
                    if (!flag && this.state.isMovePopoverVisible) {
                      setTimeout(() => {
                        this.setIsPageContextDropdownVisible(flag);
                        if (!flag) {
                          this.setIsDeleteConfirmVisible(false);
                        }
                      }, 0);
                      return;
                    }
                    this.setIsPageContextDropdownVisible(flag);
                    if (!flag) {
                      this.setIsDeleteConfirmVisible(false);
                    }
                  }}
                  overlay={
                    <Menu
                      className="nav-sidebar__dropdown-menu"
                      onClick={(e) => {
                        e.domEvent.stopPropagation();
                      }}
                    >
                      <Menu.Item
                        key="duplicate"
                        className="nav-sidebar__dropdown-item"
                        disabled={
                          this.props.websitesPages
                            .isWaitingForCloneWebsitePageResponse
                        }
                        onClick={() => {
                          const { currentWebsitePage, currentWebsite } =
                            this.props.getCurrentStoreData();
                          this.props
                            .duplicatePage(currentWebsitePage)
                            .then((response) => {
                              this.props.history.push(
                                `/${_.get(currentWebsite, "subdomain")}/pages/${
                                  response.data.id
                                }`
                              );
                              window.scrollTo(0, 0);
                              this.setIsPageContextDropdownVisible(false);
                            });
                        }}
                      >
                        <div className="nav-sidebar__dropdown-item-inner">
                          <div className="nav-sidebar__dropdown-item-icon">
                            {!this.props.websitesPages
                              .isWaitingForCloneWebsitePageResponse && (
                              <Copy size={16} />
                            )}
                            {this.props.websitesPages
                              .isWaitingForCloneWebsitePageResponse && (
                              <LoaderAnimated />
                            )}
                          </div>
                          <span className="nav-sidebar__dropdown-item-name">
                            Duplicate
                          </span>
                        </div>
                      </Menu.Item>
                      {myOtherWebsites.length > 0 && (
                        <Menu.Item
                          key="move"
                          className="nav-sidebar__dropdown-item"
                          disabled={
                            this.props.websitesPages
                              .isWaitingForMoveWebsitePageResponse
                          }
                        >
                          <MovePagePopover
                            isMovePopoverVisible={
                              this.state.isMovePopoverVisible
                            }
                            onVisibleChange={(visible) => {
                              if (
                                this.props.websitesPages
                                  .isWaitingForMoveWebsitePageResponse
                              )
                                return;
                              this.setIsMovePopoverVisible(visible);
                            }}
                            page={this.props.currentWebsitePage}
                            setIsMovePopoverVisible={
                              this.setIsMovePopoverVisible
                            }
                            placement="left"
                            // align={{ offset: [0, -60] }}
                          >
                            <div className="nav-sidebar__dropdown-item-inner">
                              <div className="nav-sidebar__dropdown-item-icon">
                                {!this.props.websitesPages
                                  .isWaitingForMoveWebsitePageResponse && (
                                  <CornerUpRight size={16} />
                                )}
                                {this.props.websitesPages
                                  .isWaitingForMoveWebsitePageResponse && (
                                  <LoaderAnimated />
                                )}
                              </div>
                              <span className="nav-sidebar__dropdown-item-name">
                                Move to
                              </span>
                            </div>
                          </MovePagePopover>
                        </Menu.Item>
                      )}

                      <Menu.Item
                        key="delete"
                        className="nav-sidebar__dropdown-item"
                        disabled={
                          this.props.websitesPages
                            .isWaitingForDeleteWebsitePageResponse
                        }
                        onClick={() => {
                          this.setIsDeleteConfirmVisible(true);
                        }}
                      >
                        {!this.state.isDeleteConfirmVisible && (
                          <div className="nav-sidebar__dropdown-item-inner">
                            <div className="nav-sidebar__dropdown-item-icon">
                              <Trash2 size={16} />
                            </div>
                            <span className="nav-sidebar__dropdown-item-name">
                              Delete
                            </span>
                          </div>
                        )}
                        {this.state.isDeleteConfirmVisible && (
                          <DeleteButtons
                            loading={
                              this.props.websitesPages
                                .isWaitingForDeleteWebsitePageResponse
                            }
                            deleteAction={() => {
                              const { currentWebsitePage, currentWebsite } =
                                this.props.getCurrentStoreData();
                              this.props
                                .deletePage(currentWebsitePage)
                                .then(() => {
                                  this.props.history.push(
                                    `/${_.get(
                                      currentWebsite,
                                      "subdomain"
                                    )}/pages`
                                  );
                                  window.scrollTo(0, 0);
                                });
                            }}
                            deleteItemTitle={"page"}
                            cancelAction={() => {
                              this.setIsDeleteConfirmVisible(false);
                            }}
                          />
                        )}
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={["click"]}
                  overlayClassName="nav-sidebar__dropdown-overlay is-context"
                >
                  <button className={classNames("editor__bottom-bar-button")}>
                    <Ellipsis size={16} />
                  </button>
                </Dropdown>
              ),
            },
            {
              tooltip: "Page settings",
              icon: <Settings size={16} />,
              onClick: () => {
                this.props.setSettingsModalType("page");
                this.props.setIsSettingsModalVisible(true);
              },
            },
          ]}
          isSecondButtonHidden={
            !hasComponents ||
            !slugParam ||
            !_.get(this.props.user, "data.feature_flags.hasNewCmsLogic", false)
          }
          secondButtonJsx={
            <button
              style={{ marginLeft: 6, padding: "8px 12px" }}
              onClick={this.showEditItemDataDrawer}
              className="nav-sidebar__cta-button"
            >
              <span className="nav-sidebar__cta-button-text">Edit data</span>
            </button>
          }
        />

        <CustomColorsStyles currentWebsite={this.currentWebsite} />
        <CustomFontsStyles currentWebsite={this.currentWebsite} />
        <CustomStyles currentWebsite={this.currentWebsite} />
        <VersionMismatchModal
          visible={this.state.isVersionMismatchModalVisible}
          onCancel={() => {
            this.setState({ isVersionMismatchModalVisible: false });
          }}
          onOk={() => {
            this.setState({ isVersionMismatchModalVisible: false });
            setTimeout(() => {
              this.savePageData(true);
            }, 200);
          }}
        />
        <Drawer
          title={null}
          placement="right"
          closable={false}
          onClose={this.hideEditItemDataDrawer}
          visible={this.state.isEditItemDataDrawerVisible}
          className="edit-item-data__drawer"
          width={600}
        >
          <EditItemDataIframe />
        </Drawer>
      </div>
    );
  }
}

export default Editor;
